import Home from "pages/Home-Winaz-3";
import HomeWinazLive from "pages/Home-Winaz-Live";
import HomeWinaz29K from "pages/Home-Winaz-29K";
import HomeWinazTanThu from "pages/Home-Winaz-Tan-Thu";
import HomeWinazNo2 from "pages/Home-Winaz-No2";
import HomeWinazVip from "pages/Home-Winaz-VIP";
import HomeWinazX3Von from "pages/Home-Winaz-X3-Von";
import HomeWinazRutNhanh from "pages/Home-Winaz-Rut-Nhanh";
import HomeWinazHoanTra20 from "pages/Home-Winaz-Hoan-Tra-20";
import HomeWinazTLMN1 from "pages/Home-Winaz-TLMN-1";
import HomeWinazTLMN2 from "pages/Home-Winaz-TLMN-2";
import HomeWinazXocDia from "pages/Home-Winaz-XocDia";
import ShortLanding from "pages/ShortLanding";
import ShortLanding2 from "pages/ShortLanding-2";
import SimpleLanding from "pages/SimpleLanding";
import ClubLanding from "pages/BizLanding";
import {
  is29KLanding,
  isClubLanding,
  isLiveLanding,
  isNo2Landing,
  isShortLanding,
  isShortLanding2,
  isSimpleLanding,
  isTanThuLanding,
  isTLMN2Landing,
} from "config/domainMode";
import { type ExperimentTheme } from "hooks/useExperiment";

const THEME_COMPONENT_MAP: Record<string, React.ComponentType> = {
  simple: SimpleLanding,
  full: Home,
  promote_xocdia_live: HomeWinazLive,
  "29k": HomeWinaz29K,
  tan_thu: HomeWinazTanThu,
  no2: HomeWinazNo2,
  vip: HomeWinazVip,
  x3_von: HomeWinazX3Von,
  rut_nhanh: HomeWinazRutNhanh,
  hoan_tra_20: HomeWinazHoanTra20,
  tlmn1: HomeWinazTLMN1,
  tlmn2: HomeWinazTLMN2,
  xoc_dia: HomeWinazXocDia,
};

const getDomainFallbackPage = (): React.ComponentType => {
  if (isLiveLanding()) return HomeWinazLive;
  if (is29KLanding()) return HomeWinaz29K;
  if (isTanThuLanding()) return HomeWinazTanThu;
  if (isNo2Landing()) return HomeWinazNo2;
  if (isSimpleLanding()) return SimpleLanding;
  if (isShortLanding2()) return ShortLanding2;
  if (isShortLanding()) return ShortLanding;
  if (isTLMN2Landing()) return HomeWinazTLMN2;
  return Home;
};

export const getLandingComponent = (
  theme?: ExperimentTheme,
): React.ComponentType => {
  if (isClubLanding()) return ClubLanding;
  if (theme && THEME_COMPONENT_MAP[theme]) {
    return THEME_COMPONENT_MAP[theme];
  }
  return getDomainFallbackPage();
};
